export const FEATURES_GLOSSARY = [
  {
    key: 'features.name',
    label: 'Funcionalidade',
    whatIs: 'Funcionalidade do produto no catálogo do PI, com o módulo e o número dela. Customizações por cliente e chaves técnicas ficam fora.',
    purpose: 'Identifica o que está sendo medido. O nome abre o detalhe da funcionalidade com os mesmos filtros.',
    howGenerated: 'Nome e módulo vêm do catálogo de funcionalidades do PI, o mesmo de "Status e catálogo"; só entram as de produto, ativas e com pelo menos um evento medido.',
  },
  {
    key: 'features.featureType',
    label: 'Número da funcionalidade',
    whatIs: 'Código da funcionalidade no catálogo do PI, o mesmo número usado pelo sistema para liberar a funcionalidade para a empresa.',
    purpose: 'Cruza a planilha com o cadastro de funcionalidades e com outras telas sem depender do nome.',
    howGenerated: 'Vem do catálogo de funcionalidades do PI.',
  },
  {
    key: 'features.module',
    label: 'Módulo da funcionalidade',
    whatIs: 'Área do produto a que a funcionalidade pertence, como Controle de Jornada, Departamento Pessoal ou Documentos e Assinaturas.',
    purpose: 'Agrupa funcionalidades para comparar o uso dentro de uma mesma área.',
    howGenerated: 'Vem do catálogo de funcionalidades do PI; o filtro Módulo mostra só as funcionalidades daquela área.',
  },
  {
    key: 'features.eligibleCompanies',
    label: 'Empresas elegíveis',
    whatIs: 'Empresas do universo ativo que tinham a funcionalidade liberada no último dia fechado do período. Sem chave de liberação, todas as empresas do universo.',
    purpose: 'É a base da adoção por empresa. Elegível que não usou é oportunidade de ativação; elegível que nunca configurou é trabalho de implantação.',
    howGenerated: 'Retrato noturno das funcionalidades liberadas em cada banco (período em que a chave esteve ligada), no último dia fechado do período. O cálculo é do fechamento diário.',
    caveat: 'Empresa sem nenhum usuário com papel que usa a funcionalidade também conta aqui; com filtro de papel, só as que têm usuário daquele papel.',
    seeAlso: ['features.adoptingCompanies', 'features.configured'],
  },
  {
    key: 'features.configured',
    label: 'Configurada',
    whatIs: 'Empresas do universo ativo, com a funcionalidade liberada, que estão com ela configurada hoje; em algumas, também a quantidade configurada (colaboradores ou modelos).',
    purpose: 'Separa quem só tem a funcionalidade liberada de quem já a deixou pronta para uso: é o passo entre contratar e usar.',
    howGenerated: 'Lido do cadastro de cada banco na foto diária, só para as funcionalidades que têm essa leitura. É o estado atual, não o histórico do período.',
    seeAlso: ['features.eligibleCompanies'],
  },
  {
    key: 'features.adoptingCompanies',
    label: 'Empresas que usaram',
    whatIs: 'Empresas elegíveis com pelo menos um usuário elegível que usou a funcionalidade com sucesso nos 30 dias até o último dia fechado do período.',
    purpose: 'Compare com as empresas elegíveis para achar quem contratou e não usa: é a lista de ativação do time de sucesso do cliente.',
    howGenerated: 'Do cálculo de adoção do fechamento diário: eventos da funcionalidade concluídos com sucesso, cruzados com os usuários elegíveis de cada empresa.',
    seeAlso: ['features.companyAdoption', 'features.eligibleCompanies'],
  },
  {
    key: 'features.companyAdoption',
    label: 'Empresas que usaram (% das elegíveis)',
    whatIs: 'Empresas que usaram ÷ empresas elegíveis × 100, na janela de 30 dias até o último dia fechado do período.',
    purpose: 'Mostra quanto da base que contratou de fato usa a funcionalidade, independente do tamanho das empresas.',
    howGenerated: 'Conta feita pela API com as duas contagens do cálculo de adoção do fechamento diário.',
    caveat: 'Empresa elegível sem nenhum usuário elegível conta no denominador.',
    metricKey: 'feature_company_adoption',
  },
  {
    key: 'features.eligibleUsers',
    label: 'Usuários elegíveis',
    whatIs: 'Usuários habilitados hoje, com papel que a funcionalidade aceita, em empresas do universo que a têm liberada no último dia fechado do período.',
    purpose: 'É o denominador da adoção: quem poderia usar a funcionalidade.',
    howGenerated: 'Cruza o cadastro atual de usuários (habilitado e papel) com as empresas que têm a funcionalidade liberada no dia, no cálculo de adoção do fechamento diário.',
    caveat: 'O habilitado é o de hoje, não o de cada dia da janela.',
  },
  {
    key: 'features.adoptingUsers',
    label: 'Usuários ativos na funcionalidade',
    whatIs: 'Usuários elegíveis com pelo menos um uso da funcionalidade concluído com sucesso nos 30 dias até o último dia fechado do período. São os adotantes.',
    purpose: 'É o numerador da adoção e a base da recorrência e da frequência.',
    howGenerated: 'Eventos da funcionalidade coletados a cada 15 minutos e somados por usuário e dia no fechamento diário; conta qualquer evento medido, inclusive consulta quando é o único sinal.',
    seeAlso: ['features.adoption'],
  },
  {
    key: 'features.adoption',
    label: 'Adoção',
    whatIs: 'Parte de quem pode usar a funcionalidade que de fato usou: usuários ativos na funcionalidade ÷ usuários elegíveis × 100, nos 30 dias até o último dia fechado do período.',
    purpose: 'Compara o uso entre funcionalidades e ao longo do tempo com uma régua só, independente do tamanho da base.',
    howGenerated: 'Cálculo de adoção do fechamento diário (00:30, horário de Brasília), janela móvel de 30 dias. Com "Comparar", a variação é contra o mesmo cálculo no fim do período anterior.',
    caveat: 'Com menos de 30 elegíveis sai "Dados insuficientes"; sem evento medido, "Sem medição". Aceita um corte por vez: papel, porte ou perfil da empresa.',
    metricKey: 'feature_adoption',
    seeAlso: ['features.eligibleUsers', 'features.adoptingUsers'],
  },
  {
    key: 'features.adoptionDelta',
    label: 'Δ adoção',
    whatIs: 'Diferença, em pontos percentuais, entre a adoção do período e a do período anterior de mesmo tamanho.',
    purpose: 'Mostra a direção da adoção: é a base da classificação "Em crescimento" e "Em queda".',
    howGenerated: 'Adoção atual menos a anterior, as duas do cálculo de adoção do fechamento diário. Só aparece com "Comparar" ligado e com a janela anterior completa.',
    seeAlso: ['features.classification'],
  },
  {
    key: 'features.recurrence',
    label: 'Recorrência',
    whatIs: 'Parte dos adotantes que usou a funcionalidade em pelo menos 2 semanas diferentes (segunda a domingo) nos 30 dias.',
    purpose: 'Separa uso pontual de uso repetido. Em funcionalidade de ciclo mensal (fechamento, espelho, férias), recorrência baixa é o esperado.',
    howGenerated: 'Do cálculo de adoção do fechamento diário: adotantes com uso bem-sucedido em 2 ou mais semanas ÷ adotantes × 100.',
    caveat: 'A régua é a mesma para toda funcionalidade, qualquer que seja a frequência esperada dela.',
    metricKey: 'feature_recurrence',
  },
  {
    key: 'features.frequency',
    label: 'Frequência',
    whatIs: 'Ações bem-sucedidas na funcionalidade, em média, por adotante e por semana nos 30 dias.',
    purpose: 'Mede a intensidade do uso de quem adotou: separa quem usa uma vez de quem usa várias vezes por semana.',
    howGenerated: 'Ações bem-sucedidas dos adotantes ÷ adotantes ÷ 4,29 semanas (30 ÷ 7), do cálculo de adoção do fechamento diário.',
    caveat: 'Se a medição da funcionalidade começou há menos de 30 dias (estado parcial), o valor sai subestimado.',
    metricKey: 'feature_frequency',
  },
  {
    key: 'features.intensity',
    label: 'Intensidade',
    whatIs: 'Mediana de dias diferentes, nos 30 dias, em que cada adotante usou a funcionalidade.',
    purpose: 'Mostraria se o uso é espalhado no mês ou concentrado em poucos dias.',
    howGenerated: 'Ainda não é calculada: os dias com uso por adotante não são pré-agregados, então sai n/d em todas as funcionalidades.',
    metricKey: 'feature_intensity',
  },
  {
    key: 'features.successRate',
    label: 'Sucesso da funcionalidade',
    whatIs: 'Ações da funcionalidade que terminaram bem ÷ ações tentadas × 100 nos 30 dias.',
    purpose: 'Aponta funcionalidade usada mas com falha frequente, que frustra quem tenta.',
    howGenerated: 'Do cálculo de adoção do fechamento diário, com os sucessos e as falhas registrados nos eventos da funcionalidade.',
    caveat: 'Só existe quando a falha é registrada, como no espelho, no facial e no relatório avançado; nas demais sai n/d. Com menos de 30 tentativas, "Dados insuficientes".',
    metricKey: 'success_rate',
  },
  {
    key: 'features.classification',
    label: 'Classificação',
    whatIs: 'Selo que resume a situação da funcionalidade: Liberada e pouco usada, Em crescimento, Em queda, Estável ou Sem classificação.',
    purpose: 'Prioriza onde olhar primeiro. Os botões acima da tabela filtram pela classificação e mostram quantas há em cada uma.',
    howGenerated: 'Regra da API sobre a adoção: pouco usada quando a adoção fica abaixo de 10% com 20 empresas elegíveis ou mais; crescimento ou queda com variação de 2 pontos percentuais ou mais contra o período anterior.',
    caveat: 'A comparação com o período anterior vale mesmo com "Comparar" desligado; só a coluna Δ adoção depende dele.',
    seeAlso: ['features.adoptionDelta'],
  },
  {
    key: 'features.classification.opportunity',
    label: 'Liberada e pouco usada',
    whatIs: 'Funcionalidade liberada em 20 empresas elegíveis ou mais e com adoção abaixo de 10%.',
    purpose: 'É a lista de oportunidade de ativação: muita gente pode usar e quase ninguém usa.',
    howGenerated: 'Regra da API sobre a adoção de 30 dias e as empresas elegíveis; só vale com o número medido (estado Medido).',
  },
  {
    key: 'features.classification.growing',
    label: 'Em crescimento',
    whatIs: 'Funcionalidade cuja adoção subiu 2 pontos percentuais ou mais contra o período anterior.',
    purpose: 'Mostra o que está ganhando uso, por exemplo depois de um lançamento ou de uma campanha.',
    howGenerated: 'Regra da API sobre a adoção de 30 dias no fim do período e no fim do período anterior de mesmo tamanho; exige as duas janelas completas.',
  },
  {
    key: 'features.classification.declining',
    label: 'Em queda',
    whatIs: 'Funcionalidade cuja adoção caiu 2 pontos percentuais ou mais contra o período anterior.',
    purpose: 'Sinal de atenção: pode ser mudança de produto, problema técnico ou perda de interesse.',
    howGenerated: 'Regra da API sobre a adoção de 30 dias no fim do período e no fim do período anterior de mesmo tamanho; exige as duas janelas completas.',
  },
  {
    key: 'features.classification.stable',
    label: 'Estável',
    whatIs: 'Funcionalidade cuja adoção variou menos de 2 pontos percentuais contra o período anterior.',
    purpose: 'Indica que nada relevante mudou no uso.',
    howGenerated: 'Regra da API sobre a adoção de 30 dias no fim do período e no fim do período anterior de mesmo tamanho; exige as duas janelas completas.',
  },
  {
    key: 'features.classification.none',
    label: 'Sem classificação',
    whatIs: 'Funcionalidade sem base para classificar: número indisponível, amostra pequena, janela de 30 dias incompleta ou sem período anterior para comparar.',
    purpose: 'Evita classificar como estável o que na verdade não tem dado suficiente.',
    howGenerated: 'A API só classifica com o estado Medido ou Parcial e com valor de adoção; sem valor anterior, só a classificação de pouco usada é possível.',
  },
  {
    key: 'features.state',
    label: 'Estado da funcionalidade',
    whatIs: 'Situação do número de adoção: Medido, Parcial, Retroativo, Sem uso, Dados insuficientes, Sem elegíveis, Não habilitada, Sem medição ou n/d.',
    purpose: 'Diz se a adoção pode ser lida como definitiva e separa "não contratada" de "contratada e não usada". O filtro Estado lista só os estados presentes.',
    howGenerated: 'Definido pela API nesta ordem: sem medição, não habilitada, sem elegíveis, sem uso, dados insuficientes e parcial (janela incompleta ou dia não fechado).',
    seeAlso: ['common.state.no_usage', 'common.state.disabled', 'common.state.not_instrumented'],
  },
  {
    key: 'features.stateReason',
    label: 'Motivo do estado',
    whatIs: 'Explicação curta do estado da adoção, como "menos de 30 elegíveis" ou "janela de 30 dias incompleta".',
    purpose: 'Diz o que falta para o número ficar definitivo ou por que ele não existe.',
    howGenerated: 'Texto devolvido pela API junto com o estado; vem vazio quando o número está medido.',
  },
  {
    key: 'features.search',
    label: 'Buscar funcionalidade',
    whatIs: 'Busca na lista já carregada, pelo nome, pelo módulo, pelo número ou pela categoria da funcionalidade.',
    purpose: 'Acha rápido uma funcionalidade sem mudar os números da tela.',
    howGenerated: 'Feita no navegador sobre as linhas já carregadas; não refaz a consulta e não vai para o endereço da tela.',
    caveat: 'A exportação leva só as linhas que a busca, a classificação e o estado deixam na tela.',
  },
  {
    key: 'features.detailAdoption',
    label: 'Adoção (usuários)',
    whatIs: 'Usuários que usaram a funcionalidade com sucesso ÷ usuários elegíveis × 100, nos 30 dias até o último dia fechado do período.',
    purpose: 'É o número de topo da funcionalidade: a mesma régua da lista, agora com um corte opcional de papel, porte ou perfil.',
    howGenerated: 'Cálculo de adoção do fechamento diário, janela móvel de 30 dias. Com "Comparar", a variação é contra o fim do período anterior.',
    caveat: 'Com dois ou mais cortes ao mesmo tempo, sai n/d. Série, cortes, ações e empresas abaixo usam o total.',
    metricKey: 'feature_adoption',
  },
  {
    key: 'features.depth',
    label: 'Profundidade',
    whatIs: 'Ações da funcionalidade que alguém usou nos 30 dias ÷ ações medidas no catálogo × 100.',
    purpose: 'Mostra se a funcionalidade é usada por inteiro ou só em parte; diz mais nas que têm várias ações, como ponto, férias e reembolso.',
    howGenerated: 'Conta as ações distintas com pelo menos um uso bem-sucedido em toda a base nos 30 dias, do agregado diário por ação, e divide pelas ações do catálogo.',
    caveat: 'Basta uma empresa usar a ação para ela contar. Com uma ação só no catálogo, o valor é 0% ou 100%.',
    metricKey: 'feature_depth',
  },
  {
    key: 'features.timeToFirstUse',
    label: 'Tempo até o 1º uso',
    whatIs: 'Dias entre a funcionalidade ser liberada para a empresa e o primeiro uso dela.',
    purpose: 'Mostraria quanto demora para a funcionalidade liberada começar a ser usada.',
    howGenerated: 'Ainda não é calculado: depende do evento de liberação da funcionalidade pelo admin, que não é coletado. Sai n/d.',
  },
  {
    key: 'features.seriesDate',
    label: 'Dia da série',
    whatIs: 'Dia de referência do ponto da evolução, no dia local da empresa.',
    purpose: 'Identifica cada ponto para cruzar com lançamentos, campanhas e feriados.',
    howGenerated: 'Um ponto por dia do período em que o cálculo de adoção do fechamento diário já rodou.',
  },
  {
    key: 'features.seriesAdoption',
    label: 'Adoção (7 dias)',
    whatIs: 'Usuários que usaram a funcionalidade com sucesso nos 7 dias até o dia ÷ usuários elegíveis no dia × 100.',
    purpose: 'Mostra a evolução recente da adoção dia a dia, mais sensível a mudanças que a adoção de 30 dias do topo.',
    howGenerated: 'Cálculo de adoção do fechamento diário com janela de 7 dias. Antes do início da medição da funcionalidade, o ponto fica vazio.',
    caveat: 'Não compare com a adoção de 30 dias do topo: janelas diferentes dão números diferentes.',
    metricKey: 'feature_adoption',
  },
  {
    key: 'features.seriesAdopting',
    label: 'Usuários que usaram (7 dias)',
    whatIs: 'Usuários elegíveis com pelo menos um uso bem-sucedido da funcionalidade nos 7 dias até o dia.',
    purpose: 'Mostra o volume de quem usa, para ler a adoção junto com o tamanho da base.',
    howGenerated: 'Cálculo de adoção do fechamento diário com janela de 7 dias, no total, sem cortes.',
  },
  {
    key: 'features.seriesEligible',
    label: 'Usuários elegíveis (série)',
    whatIs: 'Usuários habilitados com papel que a funcionalidade aceita, em empresas que a tinham liberada no dia.',
    purpose: 'Mostra se a variação da adoção veio de mais uso ou de mudança na base, como empresas novas ou funcionalidade liberada para mais clientes.',
    howGenerated: 'Cálculo de adoção do fechamento diário, no total, sem cortes; o habilitado é o cadastro atual.',
  },
  {
    key: 'features.cutRole',
    label: 'Papel (corte da adoção)',
    whatIs: 'Papel do usuário no cadastro: Funcionário, Gestor, Admin ou Contador. Só aparecem os papéis que a funcionalidade aceita.',
    purpose: 'Mostra quem adota: a funcionalidade pode ser usada pelo gestor e não pelo funcionário, por exemplo.',
    howGenerated: 'Cálculo de adoção do fechamento diário separado por papel, janela de 30 dias até o último dia fechado do período, sem filtros.',
  },
  {
    key: 'features.cutSizeProfile',
    label: 'Porte / perfil',
    whatIs: 'Porte da empresa pelo número de funcionários (A a E) ou perfil da empresa gravado no Master.',
    purpose: 'Mostra se a adoção depende do tamanho ou da categoria comercial da empresa.',
    howGenerated: 'Cálculo de adoção do fechamento diário separado por porte e por perfil, janela de 30 dias até o último dia fechado do período, sem filtros.',
    seeAlso: ['common.sizeBand', 'common.segment'],
  },
  {
    key: 'features.cutKind',
    label: 'Corte',
    whatIs: 'Indica se a linha é um porte da empresa ou um perfil da empresa.',
    purpose: 'Separa as duas réguas, que usam as mesmas letras de A a E com critérios diferentes.',
    howGenerated: 'Vem da chave do corte devolvida pela API (porte ou perfil).',
  },
  {
    key: 'features.cutUsers',
    label: 'Usuários do corte',
    whatIs: 'Usuários que usaram a funcionalidade com sucesso de usuários elegíveis do grupo, nos 30 dias até o último dia fechado do período.',
    purpose: 'Mostra o tamanho de cada grupo, para não tirar conclusão de grupo pequeno.',
    howGenerated: 'As duas contagens saem do cálculo de adoção do fechamento diário, separado pelo corte da linha.',
  },
  {
    key: 'features.cutAdopting',
    label: 'Usuários que usaram (corte)',
    whatIs: 'Usuários elegíveis do grupo com pelo menos um uso bem-sucedido da funcionalidade nos 30 dias até o último dia fechado do período.',
    purpose: 'É o numerador da adoção do grupo.',
    howGenerated: 'Cálculo de adoção do fechamento diário separado pelo corte da linha.',
  },
  {
    key: 'features.cutEligible',
    label: 'Usuários elegíveis (corte)',
    whatIs: 'Usuários habilitados do grupo, com papel que a funcionalidade aceita, em empresas que a têm liberada.',
    purpose: 'É o denominador da adoção do grupo.',
    howGenerated: 'Cálculo de adoção do fechamento diário separado pelo corte da linha; o habilitado é o cadastro atual.',
  },
  {
    key: 'features.cutAdoption',
    label: 'Adoção do corte',
    whatIs: 'Usuários que usaram ÷ usuários elegíveis do grupo × 100, nos 30 dias até o último dia fechado do período.',
    purpose: 'Compara a adoção entre papéis, portes e perfis com a mesma régua do topo.',
    howGenerated: 'Cálculo de adoção do fechamento diário separado pelo corte da linha. Não respeita os filtros da tela e não compara com o período anterior.',
    metricKey: 'feature_adoption',
  },
  {
    key: 'features.actions',
    label: 'Ações usadas',
    whatIs: 'As ações medidas da funcionalidade (como pedir, aprovar ou recusar férias) com pessoas e quantidade de usos bem-sucedidos nos 30 dias.',
    purpose: 'Mostra que parte da funcionalidade é usada e qual fica parada.',
    howGenerated: 'Do agregado diário por ação, empresa e dia, em toda a base, nos 30 dias até o último dia fechado do período.',
    seeAlso: ['features.depth'],
  },
  {
    key: 'features.action',
    label: 'Ação',
    whatIs: 'Ação medida da funcionalidade, com o nome legível do catálogo de eventos.',
    purpose: 'Identifica cada passo da funcionalidade que o PI acompanha.',
    howGenerated: 'Vem do catálogo de eventos do PI; o nome técnico do evento vai na coluna ao lado.',
  },
  {
    key: 'features.actionEvent',
    label: 'Evento',
    whatIs: 'Nome técnico do evento que registra a ação, como people.vacation.requested.',
    purpose: 'Permite conferir a ação no catálogo de eventos em "Status e catálogo".',
    howGenerated: 'Vem do catálogo de eventos do PI.',
  },
  {
    key: 'features.actionUsers',
    label: 'Usuários da ação',
    whatIs: 'Maior número de pessoas que concluíram a ação num mesmo dia dos 30 dias, somando todas as empresas.',
    purpose: 'Dá a escala de quem usa a ação num dia de pico.',
    howGenerated: 'Do agregado diário por ação e empresa: soma das pessoas de cada empresa no dia e, entre os 30 dias, o maior valor.',
    caveat: 'Não é o total de pessoas distintas nos 30 dias.',
  },
  {
    key: 'features.actionEvents',
    label: 'Usos da ação',
    whatIs: 'Quantas vezes a ação foi concluída com sucesso nos 30 dias, em toda a base.',
    purpose: 'Mostra o volume de cada ação e quais concentram o uso da funcionalidade.',
    howGenerated: 'Soma dos usos bem-sucedidos do agregado diário por ação, nos 30 dias até o último dia fechado do período.',
  },
  {
    key: 'features.actionShare',
    label: 'Usos da ação (% do total)',
    whatIs: 'Usos da ação ÷ usos de todas as ações da funcionalidade × 100, nos 30 dias.',
    purpose: 'Mostra o peso de cada ação dentro da funcionalidade.',
    howGenerated: 'Conta feita pelo Master com os usos devolvidos pela API para cada ação.',
  },
  {
    key: 'features.topPeakUsers',
    label: 'Usuários no dia de pico',
    whatIs: 'Pessoas elegíveis hoje que usaram a funcionalidade com sucesso no dia de maior uso da empresa nos 30 dias.',
    purpose: 'Mostra as contas com mais gente usando ao mesmo tempo; favorece empresa grande.',
    howGenerated: 'Do agregado diário por ação e empresa: o dia com mais pessoas de cada empresa do universo; entram as 10 maiores entre as 25 com o pico mais alto.',
    caveat: 'Para comparar empresas de tamanhos diferentes, use "Empresas por adoção".',
  },
  {
    key: 'features.topEligibleToday',
    label: 'Elegíveis de hoje',
    whatIs: 'Usuários habilitados agora na empresa, com papel que a funcionalidade aceita.',
    purpose: 'É a base do percentual da coluna ao lado.',
    howGenerated: 'Contados no cadastro atual de usuários do PI, no momento da consulta.',
  },
  {
    key: 'features.topAdoption',
    label: '% dos elegíveis de hoje',
    whatIs: 'Usuários no dia de pico ÷ elegíveis de hoje × 100.',
    purpose: 'Dá uma ideia do alcance da funcionalidade na empresa no melhor dia.',
    howGenerated: 'Conta feita pela API com as duas colunas ao lado.',
    caveat: 'Não é a adoção de 30 dias da empresa, que está em "Empresas por adoção".',
  },
  {
    key: 'features.minEligible',
    label: 'Mínimo de elegíveis por empresa',
    whatIs: 'Número mínimo de usuários elegíveis para a empresa entrar na lista: 5, 10 (padrão), 20 ou 50.',
    purpose: 'Evita que empresa com 2 ou 3 elegíveis apareça com 100% de adoção e domine a ordem.',
    howGenerated: 'Aplicado pela API depois do cálculo por empresa; as empresas abaixo do mínimo saem da lista, mas continuam nos totais da conferência.',
  },
  {
    key: 'features.journeyAtEnd',
    label: 'Jornada no fim da janela',
    whatIs: 'Etapa da empresa na jornada do cliente gravada no Master (Lead, Onboarding, Middle, Ongoing ou Resale) no último dia da janela de 30 dias.',
    purpose: 'Restringe a lista a uma etapa, por exemplo para ver a adoção só de quem está em onboarding.',
    howGenerated: 'Lida do retrato noturno do cadastro da empresa no dia de referência. Com jornada, os totais deixam de se comparar com a adoção da ficha.',
    seeAlso: ['common.journey'],
  },
  {
    key: 'features.byCompany.rank',
    label: 'Posição',
    whatIs: 'Posição da empresa na ordem escolhida, contando as páginas anteriores.',
    purpose: 'Mostra onde a empresa está entre as que usam a funcionalidade.',
    howGenerated: 'Numerada pela API depois de ordenar; no empate, entra o segundo critério da ordem (adotantes ou % de adoção).',
  },
  {
    key: 'features.byCompany.adoption',
    label: 'Adoção da empresa',
    whatIs: 'Adotantes ÷ elegíveis da empresa × 100 nos 30 dias até o último dia com adoção calculada, com a mesma regra de elegibilidade da adoção da ficha.',
    purpose: 'Compara a aderência entre empresas de tamanhos diferentes e mostra quem contratou e não usa.',
    howGenerated: 'Do agregado por empresa e janela de 30 dias, gravado junto com a adoção no fechamento diário. Com filtro de papel, só os usuários daquele papel.',
    metricKey: 'feature_adoption',
    seeAlso: ['features.byCompany.adopters', 'features.byCompany.eligible'],
  },
  {
    key: 'features.byCompany.adopters',
    label: 'Adotantes da empresa',
    whatIs: 'Usuários elegíveis da empresa que usaram a funcionalidade com sucesso nos 30 dias.',
    purpose: 'É o numerador da adoção da empresa e o tamanho absoluto do uso.',
    howGenerated: 'Do agregado por empresa e janela de 30 dias do fechamento diário.',
  },
  {
    key: 'features.byCompany.eligible',
    label: 'Elegíveis da empresa',
    whatIs: 'Usuários habilitados da empresa com papel que usa a funcionalidade, com a funcionalidade liberada no dia de referência.',
    purpose: 'É o denominador da adoção da empresa.',
    howGenerated: 'Do agregado por empresa e janela de 30 dias do fechamento diário; o habilitado é o cadastro atual.',
  },
  {
    key: 'features.byCompany.recurrent',
    label: 'Recorrentes da empresa',
    whatIs: 'Adotantes da empresa que usaram a funcionalidade em pelo menos 2 semanas diferentes nos 30 dias.',
    purpose: 'Separa empresa com uso repetido de empresa com uso pontual.',
    howGenerated: 'Do agregado por empresa e janela de 30 dias do fechamento diário.',
    caveat: 'Com filtro de papel, fica vazio: só existe no total da empresa.',
  },
  {
    key: 'features.byCompany.recurrentShare',
    label: 'Recorrentes (% dos adotantes)',
    whatIs: 'Recorrentes ÷ adotantes da empresa × 100.',
    purpose: 'Compara a recorrência entre empresas de tamanhos diferentes.',
    howGenerated: 'Conta feita pelo Master com as duas colunas devolvidas pela API.',
  },
  {
    key: 'features.byCompany.events',
    label: 'Ações da empresa',
    whatIs: 'Ações bem-sucedidas na funcionalidade feitas pelos adotantes da empresa nos 30 dias.',
    purpose: 'Mostra a intensidade de uso da conta.',
    howGenerated: 'Do agregado por empresa e janela de 30 dias do fechamento diário.',
    caveat: 'Com filtro de papel, fica vazio: só existe no total da empresa.',
  },
  {
    key: 'features.patterns.group',
    label: 'Grupo de uso',
    whatIs: 'Grupo da empresa pela regularidade de uso na janela: Uso recorrente (75% ou mais dos períodos), Uso esporádico, Sem uso no período ou, em funcionalidade eventual, Usou no período.',
    purpose: 'Mostra quantas empresas fizeram da funcionalidade um hábito e quantas usam de vez em quando.',
    howGenerated: 'Calculado na consulta a partir dos agregados diários de uso por usuário. A janela segue a frequência esperada: 4 semanas fechadas, 2 meses fechados ou 90 dias.',
    caveat: 'No controle de ponto, os grupos são pela fração dos colaboradores que bateram ponto em 28 dias: 80% ou mais, 50% a 79% e abaixo de 50%.',
  },
  {
    key: 'features.patterns.companies',
    label: 'Empresas do grupo',
    whatIs: 'Quantas empresas analisadas caíram no grupo.',
    purpose: 'Dá o tamanho de cada grupo; com menos de 30 empresas, os percentuais do grupo são só descritivos.',
    howGenerated: 'Entram empresas do universo criadas antes da janela, com a funcionalidade liberada a janela toda e com 3 usuários elegíveis ou mais.',
  },
  {
    key: 'features.patterns.share',
    label: 'Empresas do grupo (% do total)',
    whatIs: 'Empresas do grupo ÷ empresas analisadas × 100.',
    purpose: 'Mostra o peso de cada grupo, para comparar funcionalidades de bases diferentes.',
    howGenerated: 'Conta feita pela API com as empresas do grupo e as empresas analisadas na janela.',
  },
  {
    key: 'features.patterns.medianUserShare',
    label: 'Mediana de usuários que usam ÷ elegíveis',
    whatIs: 'Em cada empresa do grupo, usuários que usaram ÷ usuários elegíveis × 100; a coluna mostra a mediana entre as empresas.',
    purpose: 'Diz se o uso na empresa típica do grupo é de poucas pessoas ou de quase todas.',
    howGenerated: 'Mediana calculada na consulta sobre as empresas do grupo, com o uso bem-sucedido na janela.',
  },
  {
    key: 'features.patterns.medianActiveDays',
    label: 'Mediana de dias com uso',
    whatIs: 'Em cada empresa do grupo, dias da janela com algum uso; a coluna mostra a mediana entre as empresas.',
    purpose: 'Mostra quantos dias a empresa típica do grupo usa a funcionalidade.',
    howGenerated: 'Mediana calculada na consulta sobre as empresas do grupo, com os dias de uso bem-sucedido na janela.',
  },
  {
    key: 'features.patterns.partialActions',
    label: 'Uso de parte das ações',
    whatIs: 'Empresas do grupo que usaram menos da metade das ações da funcionalidade na janela.',
    purpose: 'Aponta empresas que usam só um pedaço da funcionalidade, por exemplo pedem e não aprovam.',
    howGenerated: 'Só vale para funcionalidade com 3 ou mais ações no catálogo; conta as ações distintas usadas por empresa no agregado diário por ação.',
  },
  {
    key: 'features.patterns.attribute',
    label: 'Atributo',
    whatIs: 'Característica da empresa comparada entre os grupos: porte, tipo de plano, antiguidade, canal de uso ou papéis que usam.',
    purpose: 'Mostra quem está em cada grupo. É associação, não causa: não explica o uso.',
    howGenerated: 'Calculado na consulta sobre as empresas analisadas, com o cadastro e o uso da janela.',
  },
  {
    key: 'features.patterns.attributeValue',
    label: 'Valor do atributo',
    whatIs: 'Valor da característica na linha, como Porte A, plano mensal ou canal app.',
    purpose: 'Identifica a fatia de empresas comparada entre os grupos.',
    howGenerated: 'Vem do retrato noturno da empresa (porte, plano, data de criação) ou do uso na janela (canal e papéis).',
  },
  {
    key: 'features.patterns.groupShare',
    label: 'Empresas do grupo com o atributo (%)',
    whatIs: 'Empresas do grupo com o valor da linha ÷ empresas do grupo × 100.',
    purpose: 'Compara a composição dos grupos: uma diferença grande sugere onde investigar.',
    howGenerated: 'Calculado na consulta. Canal e papéis não somam 100%, porque a mesma empresa usa vários canais e tem vários papéis.',
    caveat: 'Grupo com menos de 30 empresas é amostra pequena: o percentual descreve o grupo, mas não sustenta diferença.',
  },
  {
    key: 'features.patterns.flow',
    label: 'Fluxo de duas etapas',
    whatIs: 'Par de ações que forma um ciclo: um início (como pedir férias) e uma conclusão (aprovar ou recusar).',
    purpose: 'Mostra se o que é iniciado chega ao fim dentro do sistema.',
    howGenerated: 'Lista fixa de fluxos do PI (férias, reembolso, ajuste, solicitação de documento, assinatura e espelho), só com eventos medidos desde o início da janela.',
  },
  {
    key: 'features.patterns.flowEvents',
    label: 'Eventos do fluxo',
    whatIs: 'Nome técnico do evento de início e dos eventos que contam como conclusão.',
    purpose: 'Permite conferir os eventos no catálogo de "Status e catálogo".',
    howGenerated: 'Vem da definição fixa dos fluxos do PI.',
  },
  {
    key: 'features.patterns.flowCompanies',
    label: 'Empresas com 5 ou mais inícios',
    whatIs: 'Empresas analisadas que iniciaram o fluxo pelo menos 5 vezes na janela.',
    purpose: 'É a base da mediana: empresa com poucos inícios distorceria a conclusão.',
    howGenerated: 'Contagem dos eventos de início por empresa no agregado diário por ação, na janela da funcionalidade.',
  },
  {
    key: 'features.patterns.flowMedian',
    label: 'Mediana de conclusão ÷ início',
    whatIs: 'Em cada empresa com 5 ou mais inícios, conclusões ÷ inícios × 100; a coluna mostra a mediana entre essas empresas.',
    purpose: 'Abaixo de 50% sugere atrito no fluxo ou decisão tomada fora do sistema.',
    howGenerated: 'Calculado na consulta com os eventos de início e de conclusão do agregado diário por ação.',
  },
  {
    key: 'features.patterns.flowBelowHalf',
    label: 'Empresas abaixo da metade',
    whatIs: 'Empresas com 5 ou mais inícios que concluíram menos da metade do que iniciaram.',
    purpose: 'Dá a lista de tamanho do problema: quantas contas deixam o fluxo pela metade.',
    howGenerated: 'Calculado na consulta com os eventos de início e de conclusão do agregado diário por ação.',
  },
  {
    key: 'features.patterns.role',
    label: 'Papel (cobertura)',
    whatIs: 'Papel do usuário (Funcionário, Gestor, Admin ou Contador) cuja presença no uso é medida.',
    purpose: 'Mostra se os papéis que deveriam usar a funcionalidade de fato usam.',
    howGenerated: 'Os papéis vêm do cadastro atual dos usuários das empresas que usam a funcionalidade.',
  },
  {
    key: 'features.patterns.roleExpected',
    label: 'Papel no catálogo',
    whatIs: 'Indica se o catálogo do PI prevê esse papel como usuário da funcionalidade (Previsto) ou não (Não previsto).',
    purpose: 'Papel previsto com cobertura baixa pede orientação a esse público.',
    howGenerated: 'Vem dos papéis aceitos pela funcionalidade no catálogo do PI.',
  },
  {
    key: 'features.patterns.roleShare',
    label: 'Usa, entre as adotantes que têm o papel',
    whatIs: 'Entre as empresas que usam e têm esse papel habilitado, a fração em que alguém desse papel usou a funcionalidade na janela.',
    purpose: 'Mostra se o uso chega a todos os papéis previstos ou fica em um só.',
    howGenerated: 'Calculado na consulta com o cadastro atual de usuários e o uso bem-sucedido na janela.',
  },
  {
    key: 'features.patterns.roleWithUsers',
    label: 'Empresas adotantes com o papel',
    whatIs: 'Empresas que usam a funcionalidade e têm pelo menos um usuário habilitado com esse papel.',
    purpose: 'É a base do percentual de cobertura do papel.',
    howGenerated: 'Contagem feita na consulta com o cadastro atual de usuários.',
  },
  {
    key: 'features.patterns.roleAdopting',
    label: 'Empresas adotantes',
    whatIs: 'Empresas analisadas que usaram a funcionalidade na janela, tenham ou não o papel.',
    purpose: 'Mostra quantas das que usam têm o papel habilitado.',
    howGenerated: 'Contagem feita na consulta com o uso bem-sucedido na janela.',
  },
  {
    key: 'features.report.maturity',
    label: 'Maturidade do relatório avançado',
    whatIs: 'Situação da medição: Sem medição (eventos não ligados), Coletando (janela de 30 dias ainda incompleta) ou Medido desde a data em que os eventos foram ligados.',
    purpose: 'Diz se segmentos, empresas e usuários já podem ser lidos como definitivos.',
    howGenerated: 'A API compara a data em que os eventos da tela foram ligados com o início da janela de 30 dias e com a última montagem noturna.',
  },
  {
    key: 'features.report.value',
    label: 'Tiram valor',
    whatIs: 'Parte de quem entrou no relatório avançado nos 30 dias que caiu nos segmentos Tira valor ou Uso pontual: exportou ou salvou algum relatório, ou viu dados na tela em 3 dias ou mais.',
    purpose: 'Mede se a tela entrega resultado para quem a usa.',
    howGenerated: 'Pessoas desses segmentos ÷ pessoas que entraram na tela nos 30 dias até o fim do período × 100, da montagem noturna dos eventos da tela.',
    metricKey: 'report_user_segment',
    seeAlso: ['features.report.segment'],
  },
  {
    key: 'features.report.confused',
    label: 'Se confundem ou desistem',
    whatIs: 'Parte de quem entrou no relatório avançado nos 30 dias que caiu nos segmentos Só abriu, Travou ou Explorou sem resultado.',
    purpose: 'Mede o atrito da tela: quem tenta e não chega a um relatório útil.',
    howGenerated: 'Pessoas desses segmentos ÷ pessoas que entraram na tela nos 30 dias até o fim do período × 100, da montagem noturna dos eventos da tela.',
    metricKey: 'report_user_segment',
    seeAlso: ['features.report.segment'],
  },
  {
    key: 'features.report.neutral',
    label: 'Consultaram só na tela (neutro)',
    whatIs: 'Parte de quem entrou nos 30 dias que viu dados na tela sem exportar nem salvar, com poucas configurações.',
    purpose: 'Completa a conta: quem consulta na tela não é valor confirmado nem confusão.',
    howGenerated: 'Pessoas do segmento Consultou na tela ÷ pessoas que entraram na tela nos 30 dias × 100.',
    metricKey: 'report_user_segment',
  },
  {
    key: 'features.report.resultRate',
    label: 'Taxa de resultado por visita',
    whatIs: 'Visitas que executaram um relatório e terminaram em exportação ou relatório salvo ÷ visitas que executaram × 100, no período.',
    purpose: 'Mede se a visita à tela termina em algo útil fora dela.',
    howGenerated: 'Visita = eventos da mesma pessoa com menos de 30 minutos entre si. Montado toda noite com os eventos da tela; o dia corrente não aparece.',
    metricKey: 'report_visit_funnel',
  },
  {
    key: 'features.report.configsPerVisit',
    label: 'Configurações por visita (mediana)',
    whatIs: 'Mediana de configurações diferentes tentadas nas visitas que executaram algum relatório.',
    purpose: 'Mostra o esforço típico para chegar ao relatório: muitas tentativas sugerem dificuldade de montar o que se quer.',
    howGenerated: 'Configuração = relatório, modo, campos de filtro e de agrupamento, métricas e período; trocar só o valor de um filtro não muda. Montado toda noite.',
    metricKey: 'report_visit_funnel',
  },
  {
    key: 'features.report.funnelStep',
    label: 'Etapa do funil',
    whatIs: 'Etapa da visita ao relatório avançado: Abriu, Executou, Mudou a configuração, Teve resultado e Voltou em até 7 dias.',
    purpose: 'Mostra onde as visitas param antes de chegar ao resultado.',
    howGenerated: 'Cada visita é classificada pelas ações que teve, na montagem noturna dos eventos da tela, no período escolhido.',
    metricKey: 'report_visit_funnel',
  },
  {
    key: 'features.report.funnelVisits',
    label: 'Visitas da etapa',
    whatIs: 'Quantas visitas do período chegaram à etapa.',
    purpose: 'Dá o volume de cada etapa do funil.',
    howGenerated: 'Contagem das visitas na montagem noturna dos eventos da tela; visita = eventos da mesma pessoa com menos de 30 minutos entre si.',
  },
  {
    key: 'features.report.funnelRate',
    label: 'Taxa da etapa',
    whatIs: 'Visitas da etapa ÷ visitas da etapa-base × 100. Executou é fração de Abriu; as demais são frações de Executou.',
    purpose: 'Compara a passagem entre etapas independente do volume de visitas.',
    howGenerated: 'Conta feita pela API. Voltou só conta visitas que já têm os 7 dias seguintes fechados; antes disso aparece "janela aberta".',
    metricKey: 'report_visit_funnel',
  },
  {
    key: 'features.report.funnelBase',
    label: 'Base da taxa',
    whatIs: 'Etapa usada como denominador da taxa: as visitas que abriram ou as que executaram.',
    purpose: 'Evita ler as etapas como encaixadas umas nas outras: mudar, ter resultado e voltar são frações de Executou.',
    howGenerated: 'Definida pela API para cada etapa.',
  },
  {
    key: 'features.report.funnelEligible',
    label: 'Visitas elegíveis',
    whatIs: 'Visitas que executaram e já têm os 7 dias seguintes fechados; só existe na etapa Voltou.',
    purpose: 'É o denominador de quem voltou: visita recente ainda não teve tempo de voltar.',
    howGenerated: 'Contagem feita na montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.changeBranch',
    label: 'Na visita',
    whatIs: 'Separa as visitas que rodaram uma configuração só das que mudaram a configuração (2 ou mais tentadas).',
    purpose: 'Compara se mexer na configuração leva mais ou menos a resultado.',
    howGenerated: 'Contagem das configurações diferentes tentadas em cada visita que executou, na montagem noturna.',
  },
  {
    key: 'features.report.changeVisits',
    label: 'Visitas do grupo',
    whatIs: 'Visitas do período que executaram algum relatório e caíram no grupo da linha.',
    purpose: 'Dá o tamanho de cada lado: com menos de 30 visitas de um lado, a diferença não é conclusiva.',
    howGenerated: 'Contagem feita na montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.changeResult',
    label: 'Resultado do grupo',
    whatIs: 'Visitas do grupo que terminaram em exportação ou relatório salvo ÷ visitas do grupo × 100.',
    purpose: 'Mostra qual comportamento leva mais a resultado.',
    howGenerated: 'Conta feita pela API com as visitas da montagem noturna.',
    metricKey: 'report_visit_funnel',
  },
  {
    key: 'features.report.changeReturn',
    label: 'Voltou (grupo)',
    whatIs: 'Visitas do grupo com nova execução em outro dia, em até 7 dias ÷ visitas do grupo com os 7 dias seguintes fechados × 100.',
    purpose: 'Mostra se a visita gerou o hábito de voltar à tela.',
    howGenerated: 'Conta feita pela API com as visitas da montagem noturna; visita recente fica de fora até a janela de 7 dias fechar.',
    metricKey: 'report_visit_funnel',
  },
  {
    key: 'features.report.depthMeasure',
    label: 'Medida por visita',
    whatIs: 'O que é medido em cada visita que executou: configurações tentadas, execuções ou minutos na visita.',
    purpose: 'Mostra o esforço e a duração típicos de uma visita à tela.',
    howGenerated: 'Calculado por visita na montagem noturna dos eventos da tela, no período escolhido.',
  },
  {
    key: 'features.report.depthP50',
    label: 'Mediana por visita',
    whatIs: 'Valor do meio: metade das visitas que executaram fica abaixo dele e metade acima.',
    purpose: 'Mostra a visita típica, sem o efeito de poucas visitas muito longas.',
    howGenerated: 'Percentil 50 calculado sobre as visitas que executaram no período.',
  },
  {
    key: 'features.report.depthP75',
    label: 'p75 por visita',
    whatIs: 'Valor abaixo do qual estão 75% das visitas que executaram.',
    purpose: 'Mostra o esforço das visitas mais trabalhosas, sem chegar aos extremos.',
    howGenerated: 'Percentil 75 calculado sobre as visitas que executaram no período.',
  },
  {
    key: 'features.report.depthP90',
    label: 'p90 por visita',
    whatIs: 'Valor abaixo do qual estão 90% das visitas que executaram.',
    purpose: 'Mostra a cauda: as visitas mais longas ou com mais tentativas.',
    howGenerated: 'Percentil 90 calculado sobre as visitas que executaram no período.',
    caveat: 'Em minutos na visita, o servidor não manda o p90 e a célula fica vazia.',
  },
  {
    key: 'features.report.segment',
    label: 'Segmento de uso',
    whatIs: 'Grupo de cada pessoa que entrou no relatório avançado nos 30 dias, avaliado nesta ordem: Só abriu, Tira valor, Uso pontual, Travou, Explorou sem resultado e Consultou na tela.',
    purpose: 'Separa quem tira valor da tela de quem se confunde, para orientar melhorias e o suporte.',
    howGenerated: 'Cada pessoa cai no primeiro segmento que casa, pelas execuções, exportações e relatórios salvos dela nos 30 dias até o fim do período; montado toda noite.',
    caveat: 'Os limiares são da versão 1 e serão revistos com 30 dias de dados.',
    metricKey: 'report_user_segment',
  },
  {
    key: 'features.report.segmentDefinition',
    label: 'Definição do segmento',
    whatIs: 'Regra que coloca a pessoa no segmento, com os limiares usados.',
    purpose: 'Deixa explícito o critério de cada segmento na planilha.',
    howGenerated: 'Texto devolvido pela API, o mesmo da regra que classifica as pessoas.',
  },
  {
    key: 'features.report.segmentGroup',
    label: 'Grupo do segmento',
    whatIs: 'Valor (Tira valor e Uso pontual), Confusão (Só abriu, Travou e Explorou sem resultado) ou Neutro (Consultou na tela).',
    purpose: 'Junta os segmentos nas duas leituras dos indicadores: tiram valor e se confundem.',
    howGenerated: 'Fixo para cada segmento na regra do relatório avançado.',
  },
  {
    key: 'features.report.segmentUsers',
    label: 'Usuários do segmento',
    whatIs: 'Pessoas que entraram no relatório avançado nos 30 dias e caíram no segmento.',
    purpose: 'Dá o tamanho de cada segmento.',
    howGenerated: 'Contagem da montagem noturna, nos 30 dias até o fim do período, com os filtros de papel, porte e perfil.',
  },
  {
    key: 'features.report.segmentCompanies',
    label: 'Empresas do segmento',
    whatIs: 'Empresas com pelo menos uma pessoa no segmento nos 30 dias.',
    purpose: 'Mostra se o segmento está espalhado ou concentrado em poucas contas.',
    howGenerated: 'Contagem da montagem noturna, nos 30 dias até o fim do período.',
  },
  {
    key: 'features.report.segmentShare',
    label: 'Participação do segmento',
    whatIs: 'Pessoas do segmento ÷ pessoas que entraram no relatório avançado nos 30 dias × 100.',
    purpose: 'Compara o peso dos segmentos entre períodos.',
    howGenerated: 'Conta feita pela API com as contagens da montagem noturna.',
    metricKey: 'report_user_segment',
  },
  {
    key: 'features.report.record',
    label: 'Relatório',
    whatIs: 'Tipo de relatório do relatório avançado, como cadastro, jornada ou batidas.',
    purpose: 'Mostra quais relatórios são usados, dão resultado ou travam.',
    howGenerated: 'Vem do evento de execução da tela, com o nome legível do catálogo de relatórios.',
  },
  {
    key: 'features.report.mode',
    label: 'Modo do relatório',
    whatIs: 'Lista (linha a linha) ou Agrupado (com totais por um ou mais campos).',
    purpose: 'Separa o uso de listagem do uso de resumo.',
    howGenerated: 'Vem do evento de execução da tela.',
  },
  {
    key: 'features.report.groupBy',
    label: 'Agrupado por',
    whatIs: 'Campos de agrupamento usados na combinação, na ordem escolhida; "por mês" quando a data é agrupada por mês.',
    purpose: 'Mostra quais resumos as pessoas montam.',
    howGenerated: 'Vem do evento de execução da tela, com os nomes legíveis do catálogo de campos.',
  },
  {
    key: 'features.report.combination',
    label: 'Combinação de relatório',
    whatIs: 'Relatório × modo × campos de agrupamento. Colunas, filtros e período não mudam a combinação.',
    purpose: 'Mostra quais montagens dão resultado e merecem virar modelo pronto.',
    howGenerated: 'Só entram as 20 primeiras combinações executadas por 3 pessoas ou mais no período; as demais somam em "outras combinações". Montado toda noite.',
    metricKey: 'report_combination_value',
  },
  {
    key: 'features.report.comboUsers',
    label: 'Usuários da combinação',
    whatIs: 'Pessoas que executaram a combinação no período.',
    purpose: 'Mostra o alcance de cada combinação.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela, no período escolhido.',
  },
  {
    key: 'features.report.comboCompanies',
    label: 'Empresas da combinação',
    whatIs: 'Empresas com pelo menos uma pessoa que executou a combinação no período.',
    purpose: 'Mostra se a combinação é usada por muitas contas ou por poucas.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela, no período escolhido.',
  },
  {
    key: 'features.report.comboVisitsRan',
    label: 'Visitas que executaram',
    whatIs: 'Visitas do período que executaram a combinação.',
    purpose: 'É o denominador da taxa de resultado da combinação.',
    howGenerated: 'Contagem da montagem noturna; visita = eventos da mesma pessoa com menos de 30 minutos entre si.',
  },
  {
    key: 'features.report.comboVisitsResult',
    label: 'Visitas com resultado',
    whatIs: 'Visitas que executaram a combinação e exportaram ou salvaram essa mesma combinação.',
    purpose: 'É o numerador da taxa de resultado da combinação.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela, no período escolhido.',
  },
  {
    key: 'features.report.comboResultRate',
    label: 'Taxa de resultado da combinação',
    whatIs: 'Visitas com resultado ÷ visitas que executaram a combinação × 100.',
    purpose: 'Aponta as combinações que mais entregam relatório útil.',
    howGenerated: 'Conta feita pela API com as contagens da montagem noturna.',
    metricKey: 'report_combination_value',
  },
  {
    key: 'features.report.comboReturn',
    label: 'Voltaram a executar',
    whatIs: 'Pessoas que executaram a combinação com dados em 2 dias diferentes ou mais ÷ pessoas que a executaram × 100.',
    purpose: 'Mostra quais combinações viram rotina.',
    howGenerated: 'Conta feita pela API com a montagem noturna dos eventos da tela, no período escolhido.',
    metricKey: 'report_combination_value',
  },
  {
    key: 'features.report.comboUsersReturned',
    label: 'Usuários que voltaram',
    whatIs: 'Pessoas que executaram a combinação com dados em 2 dias diferentes ou mais no período.',
    purpose: 'É o numerador da taxa de quem voltou a executar.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.failure',
    label: 'Falha',
    whatIs: 'Recusa da regra do relatório (código REPORT.*) ou erro técnico do servidor, com o nome legível quando existe.',
    purpose: 'Mostra onde as pessoas travam e quais falhas pedem correção no produto.',
    howGenerated: 'Eventos de execução, exportação, salvamento, exclusão e favorito que terminaram em falha, por código e relatório, no período. Montado toda noite.',
    metricKey: 'report_run_problems',
  },
  {
    key: 'features.report.failureCode',
    label: 'Código da falha',
    whatIs: 'Código técnico devolvido pela tela: REPORT.* para recusa da regra, ou o tipo da exceção para erro técnico.',
    purpose: 'Permite achar a falha no código e no log.',
    howGenerated: 'Vem do evento registrado pela tela.',
  },
  {
    key: 'features.report.failureTechnical',
    label: 'Erro técnico',
    whatIs: 'Sim quando a falha é erro do servidor, e não recusa da regra do relatório.',
    purpose: 'Separa o que é bug do que é regra de negócio.',
    howGenerated: 'É erro técnico todo código fora de REPORT.* que não seja a exceção de negócio.',
  },
  {
    key: 'features.report.failureKind',
    label: 'Ação da falha',
    whatIs: 'O que a pessoa tentava fazer: abrir, executar, exportar, salvar, excluir ou favoritar.',
    purpose: 'Mostra em que passo da tela a falha acontece.',
    howGenerated: 'Vem do tipo do evento registrado pela tela.',
  },
  {
    key: 'features.report.failureEvents',
    label: 'Ocorrências',
    whatIs: 'Quantas vezes a falha aconteceu no período.',
    purpose: 'Dá o volume da falha.',
    howGenerated: 'Contagem dos eventos com falha na montagem noturna.',
  },
  {
    key: 'features.report.failureUsers',
    label: 'Usuários com a falha',
    whatIs: 'Pessoas que receberam a falha pelo menos uma vez no período.',
    purpose: 'Mostra quantas pessoas foram afetadas, além do volume.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.failureCompanies',
    label: 'Empresas com a falha',
    whatIs: 'Empresas com pelo menos uma pessoa que recebeu a falha no período.',
    purpose: 'Mostra se a falha atinge muitas contas ou uma só.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.failureEnded',
    label: 'Visitas que terminaram no erro',
    whatIs: 'Visitas cuja última execução foi esta falha, sem uma execução bem-sucedida depois.',
    purpose: 'Mostra a falha que faz a pessoa desistir, e não só a que ela contorna.',
    howGenerated: 'Só para falhas de execução; calculado por visita na montagem noturna.',
  },
  {
    key: 'features.report.emptyRuns',
    label: 'Execuções do relatório',
    whatIs: 'Execuções da 1ª página do relatório, no modo da linha, que tiveram resposta no período.',
    purpose: 'É a base da taxa de execuções vazias.',
    howGenerated: 'Contagem da montagem noturna; só entram relatórios com 5 execuções ou mais.',
  },
  {
    key: 'features.report.emptyCount',
    label: 'Execuções vazias',
    whatIs: 'Execuções da 1ª página que responderam sem nenhuma linha.',
    purpose: 'Aponta filtros que costumam não trazer nada, sinal de configuração difícil.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.emptyRate',
    label: 'Taxa de vazias',
    whatIs: 'Execuções vazias ÷ execuções × 100.',
    purpose: 'Compara relatórios de volumes diferentes.',
    howGenerated: 'Conta feita pela API com as contagens da montagem noturna.',
    metricKey: 'report_run_problems',
  },
  {
    key: 'features.report.emptyUsers',
    label: 'Usuários que executaram o relatório',
    whatIs: 'Pessoas que executaram o relatório no modo da linha no período, com ou sem linhas na resposta.',
    purpose: 'Mostra quantas pessoas estão por trás das execuções.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.companyUsers',
    label: 'Usuários da empresa no relatório',
    whatIs: 'Pessoas da empresa que entraram no relatório avançado nos 30 dias até o fim do período.',
    purpose: 'Ordena as empresas pelo uso da tela: a lista traz as 50 com mais pessoas.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela, com os filtros de papel, porte e perfil.',
  },
  {
    key: 'features.report.companyValue',
    label: 'Tiram valor (empresa)',
    whatIs: 'Pessoas da empresa nos segmentos Tira valor ou Uso pontual nos 30 dias.',
    purpose: 'Mostra as contas em que a tela entrega resultado.',
    howGenerated: 'Contagem da montagem noturna, com a mesma regra de segmento da tabela de segmentos.',
  },
  {
    key: 'features.report.companyConfused',
    label: 'Se confundem (empresa)',
    whatIs: 'Pessoas da empresa nos segmentos Só abriu, Travou ou Explorou sem resultado nos 30 dias.',
    purpose: 'Aponta contas que podem precisar de ajuda do suporte com a tela.',
    howGenerated: 'Contagem da montagem noturna, com a mesma regra de segmento da tabela de segmentos.',
  },
  {
    key: 'features.report.companyVisits',
    label: 'Visitas da empresa',
    whatIs: 'Visitas das pessoas da empresa ao relatório avançado nos 30 dias.',
    purpose: 'Dá a intensidade de uso da tela na conta.',
    howGenerated: 'Contagem da montagem noturna; visita = eventos da mesma pessoa com menos de 30 minutos entre si.',
  },
  {
    key: 'features.report.companyResults',
    label: 'Resultados da empresa',
    whatIs: 'Exportações e relatórios salvos pelas pessoas da empresa nos 30 dias.',
    purpose: 'Mostra quanto a conta tira da tela em relatório útil.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.user',
    label: 'Usuário',
    whatIs: 'Identificador encurtado da pessoa (últimos 4 caracteres do id), sem nome.',
    purpose: 'Diferencia as pessoas da lista sem expor quem são.',
    howGenerated: 'Encurtado no Master a partir do id do usuário devolvido pela API, que não traz nome nem e-mail de usuário de cliente.',
  },
  {
    key: 'features.report.userRole',
    label: 'Papel do usuário (relatório)',
    whatIs: 'Papel da pessoa: Admin (admin e admin secundário juntos) ou Contador, os papéis com acesso à tela.',
    purpose: 'Separa o uso de quem administra do uso do contador.',
    howGenerated: 'Vem do cadastro de usuários do PI.',
  },
  {
    key: 'features.report.userSegment',
    label: 'Segmento do usuário',
    whatIs: 'Segmento de uso em que a pessoa caiu nos 30 dias até o fim do período.',
    purpose: 'Mostra quem tira valor e quem se confunde, pessoa a pessoa.',
    howGenerated: 'Mesma regra da tabela de segmentos, calculada na montagem noturna.',
    seeAlso: ['features.report.segment'],
  },
  {
    key: 'features.report.userVisits',
    label: 'Visitas do usuário',
    whatIs: 'Visitas da pessoa ao relatório avançado nos 30 dias.',
    purpose: 'Mostra a frequência de uso da tela.',
    howGenerated: 'Contagem da montagem noturna; visita = eventos da mesma pessoa com menos de 30 minutos entre si.',
  },
  {
    key: 'features.report.userAttempts',
    label: 'Execuções do usuário',
    whatIs: 'Execuções da 1ª página feitas pela pessoa nos 30 dias, com qualquer resposta.',
    purpose: 'Mostra quanto a pessoa tenta.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.userGoodDays',
    label: 'Dias com resultado',
    whatIs: 'Dias com pelo menos uma execução na tela que respondeu e não veio vazia (ou modelo do sistema, cujo vazio é a resposta).',
    purpose: 'Três dias ou mais com dados na tela já colocam a pessoa em Tira valor.',
    howGenerated: 'Contagem por dia na montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.userConfigs',
    label: 'Configurações do usuário',
    whatIs: 'Configurações diferentes tentadas pela pessoa nos 30 dias; embaixo, quantas delas foram exportadas ou salvas.',
    purpose: 'Muitas tentativas sem resultado indicam dificuldade de montar o relatório.',
    howGenerated: 'Contagem da montagem noturna; trocar só o valor de um filtro não muda a configuração.',
  },
  {
    key: 'features.report.userResultConfigs',
    label: 'Configurações com resultado',
    whatIs: 'Configurações diferentes que a pessoa exportou ou salvou nos 30 dias.',
    purpose: 'Três ou mais colocam a pessoa em Tira valor.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.userResults',
    label: 'Resultados do usuário',
    whatIs: 'Exportações e relatórios salvos pela pessoa nos 30 dias.',
    purpose: 'Mostra quanto a pessoa tira da tela em relatório útil.',
    howGenerated: 'Contagem da montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.userBadShare',
    label: 'Execuções ruins',
    whatIs: 'Execuções vazias, recusadas ou com erro técnico ÷ execuções da pessoa × 100, nos 30 dias.',
    purpose: 'Mostra quanto a pessoa esbarra em resposta vazia, recusa ou erro; ajuda a ler o segmento Travou, que não conta o erro do servidor.',
    howGenerated: 'Conta feita na montagem noturna dos eventos da tela.',
  },
  {
    key: 'features.report.userLastVisit',
    label: 'Última visita',
    whatIs: 'Dia da última visita da pessoa ao relatório avançado nos 30 dias.',
    purpose: 'Mostra quem usou há pouco e quem parou.',
    howGenerated: 'Maior dia com evento da pessoa na montagem noturna; o dia corrente não aparece.',
  },
  {
    key: 'features.report.userTopFailure',
    label: 'Falha mais comum',
    whatIs: 'Falha que a pessoa mais recebeu nos 30 dias.',
    purpose: 'Ajuda o suporte a entender onde a pessoa trava.',
    howGenerated: 'Código de falha mais frequente da pessoa na montagem noturna, com o nome legível quando existe.',
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/features.js